import Link from 'next/link';
import styles from './InfoLint.module.css';
import { tooltips } from '@/lib/constants/tooltips';
import { Tooltip } from 'react-tooltip';
import React from 'react';
import IconReact from '@/components/ui/Icon/IconReact';

export const InfoLink = () => {
    return (
        <Link href="/info/order-number" className={styles.linkContainer}>
            <div className={styles.link}>
                <IconReact name={'ri-information-line'} />
                <p data-tooltip-id="order-number" data-tooltip-content={tooltips.orderNumber}>
                    Как найти номер отслеживания?
                    <Tooltip
                        id="order-number"
                        place="top"
                        noArrow={false}
                        style={{ zIndex: 1000, maxWidth: '250px' }}
                    />
                </p>
            </div>
        </Link>
    );
};
